<div class="company_item">
  <div class="company_item__logo">
    <span class="company_item__logo-plate">
      <svg-icon
        [src]="endpoint.logo"
        [svgStyle]="{ 'width.px': '70', 'height.rem': '2' }"
      ></svg-icon>
    </span>
  </div>
  <div class="company_item__name">{{ endpoint.name }}</div>
</div>
